module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("Audio Demo")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.speechText),
      expression: "speechText"
    }],
    attrs: {
      "placeholder": _vm.placeholder,
      "cols": "100",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.speechText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.speechText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('select', {
    ref: "voiceSelect",
    on: {
      "change": _vm.doThis
    }
  }, _vm._l((_vm.voiceOptions), function(option, index) {
    return _c('option', {
      key: index,
      attrs: {
        "index": index
      },
      domProps: {
        "value": option.title
      }
    }, [_vm._v(_vm._s(option.title))])
  })), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.readText
    }
  }, [_vm._v("Read")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b74d82c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/templates/audio.vue
// module id = 661
// module chunks = 1